import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessageService } from 'primeng/api';
import { PrimeNGSharedModule } from '../../prime/prime-ng.module'; // Assuming PrimeNG ToastModule is exported here

@Component({
  selector: 'app-toast-message',
  standalone: true,
  imports: [CommonModule, PrimeNGSharedModule], // Import PrimeNGSharedModule for p-toast
  templateUrl: "./toast-message.component.html",
  styleUrl: "./toast-message.component.scss",
})
export class ToastMessageComponent implements OnInit {
  @Input() toastKey: string = 'global'; // Optional: Use a specific key for this toast instance

  constructor(private messageService: MessageService) {}

  ngOnInit(): void {
    // No specific initialization needed here, as the service handles messages
  }

  /**
   * Shows a success toast message.
   * @param title The title of the toast.
   * @param message The main message content.
   * @param life Duration in milliseconds to show the toast (default: 3000).
   */
  showSuccess(title: string, message: string, life: number = 3000): void {
    this.messageService.add({
      key: this.toastKey,
      severity: 'success',
      summary: title,
      detail: message,
      life: life
    });
  }

  /**
   * Shows an info toast message.
   * @param title The title of the toast.
   * @param message The main message content.
   * @param life Duration in milliseconds to show the toast (default: 3000).
   */
  showInfo(title: string, message: string, life: number = 3000): void {
    this.messageService.add({
      key: this.toastKey,
      severity: 'info',
      summary: title,
      detail: message,
      life: life
    });
  }

  /**
   * Shows a warning toast message.
   * @param title The title of the toast.
   * @param message The main message content.
   * @param life Duration in milliseconds to show the toast (default: 3000).
   */
  showWarn(title: string, message: string, life: number = 3000): void {
    this.messageService.add({
      key: this.toastKey,
      severity: 'warn',
      summary: title,
      detail: message,
      life: life
    });
  }

  /**
   * Shows an error toast message.
   * @param title The title of the toast.
   * @param message The main message content.
   * @param life Duration in milliseconds to show the toast (default: 3000).
   */
  showError(title: string, message: string, life: number = 3000): void {
    this.messageService.add({
      key: this.toastKey,
      severity: 'error',
      summary: title,
      detail: message,
      life: life
    });
  }

  /**
   * Clears all messages from the toast.
   */
  clear(): void {
    this.messageService.clear(this.toastKey);
  }
}